// Turf Talk shared UI constants (mirrors design_guidelines.json + character rig)
export const CHAR_ORDER = ["alpha_moose", "bruce", "cow_pie"];

export const CHAR_NAME = {
  alpha_moose: "Alpha Moose",
  cow_pie: "Cow Pie",
  bruce: "Bruce",
};

export const CHAR_COLOR = {
  alpha_moose: "#2F7D32",
  cow_pie: "#E65100",
  bruce: "#D92D20",
};

// puppet_v2 rig — full-character frames (each frame draws exactly two arms).
const P = "/characters/puppet_v2";
export const PUPPET = {
  alpha_moose: {
    aspect: 0.8616,
    base: `${P}/alpha_moose_base.png`,
    mouth: { mbp: `${P}/alpha_moose_m_mbp.png`, e: `${P}/alpha_moose_m_e.png`, a: `${P}/alpha_moose_m_a.png`, ou: `${P}/alpha_moose_m_ou.png`, fv: `${P}/alpha_moose_m_fv.png`, lth: `${P}/alpha_moose_m_lth.png` },
    blink: `${P}/alpha_moose_eyes_blink.png`,
    brow: `${P}/alpha_moose_brow.png`,
    poses: { g_emph: `${P}/alpha_moose_pose_g_emph.png`, g_open: `${P}/alpha_moose_pose_g_open.png` },
  },
  cow_pie: {
    aspect: 0.8333,
    base: `${P}/cow_pie_base.png`,
    mouth: { mbp: `${P}/cow_pie_m_mbp.png`, e: `${P}/cow_pie_m_e.png`, a: `${P}/cow_pie_m_a.png`, ou: `${P}/cow_pie_m_ou.png`, fv: `${P}/cow_pie_m_fv.png`, lth: `${P}/cow_pie_m_lth.png` },
    blink: `${P}/cow_pie_eyes_blink.png`,
    brow: `${P}/cow_pie_brow.png`,
    poses: { g_open: `${P}/cow_pie_pose_g_open.png` },
  },
  bruce: {
    aspect: 0.9323,
    base: `${P}/bruce_base.png`,
    mouth: { mbp: `${P}/bruce_m_mbp.png`, e: `${P}/bruce_m_e.png`, a: `${P}/bruce_m_a.png`, ou: `${P}/bruce_m_ou.png`, fv: `${P}/bruce_m_fv.png`, lth: `${P}/bruce_m_lth.png` },
    poses: { g_emph: `${P}/bruce_pose_g_emph.png`, g_open: `${P}/bruce_pose_g_open.png` },
  },
};

// Openness-ordered viseme cycle used while talking (fast, visible cadence).
export const OPEN_SEQ = ["a", "ou", "e", "fv", "lth"];

export const characterArt = (id) => `/characters/${id}_master.png`;
